<app-street-thumb
  [imageUrl]="building.imageUrl"
  [isAvailable]="building.isAvailable"
  [level]="building.level"
  [mediaClass]="['large', 'small-thumb xsmall']"
  [title]="building.mainName"
  class="rounded column build-asset"
  style="grid-area: asset">
  <ng-container *mediaIf="'medium down'">
    <ng-container>{{ building.secondaryName }}</ng-container>
  </ng-container>
</app-street-thumb>

<div *mediaIf="'large'" class="column build-city">{{ building.city }}</div>
<div *mediaIf="'large'" class="column build-country">{{ building.country }}</div>

<app-level-icon
  [level]="building.level"
  [price]="-1"
  class="column build-level sm"
  style="grid-area: level"></app-level-icon>
<!-- <div class="column build-current-price" style="grid-area: your-price">
  {{ building.sellPrice | money: 'DWRLD':'—' }}
</div> -->
<div class="column build-purchase-price" style="grid-area: purchase-price">
  {{ building.lastPrice | money: 'DWRLD':'—' }}
</div>

<div class="column build-date" style="grid-area: date">{{ building.buyAt | date }}</div>

<div class="column build-buttons">
  <app-menu [align]="'center'" [minWidth]="240">
    <button
      (click)="$event.stopPropagation()"
      appAnchor
      appButton
      class="clear-primary"
      style="grid-area: menu">
      <app-icon [icon]="ellipsisIcon" class="color-primary xhg"></app-icon>
    </button>
    <ng-template>
      <div class="data-host">
        <ng-container *ngIf="!building.isReserved">
          <button
            (click)="openWithdrawNFT()"
            [appButton]="exchangeIcon"
            appMenuItem
            class="solid for-select">
            {{ 'dashboard.ui.street_item.button.withdraw' | translate }}
          </button>

          <button
            (click)="openTransferNFT()"
            *ngIf="!building.sellPrice"
            [appButton]="exchangeIcon"
            appMenuItem
            class="solid for-select">
            {{ 'dashboard.ui.street_item.button.transfer' | translate }}
          </button>
        </ng-container>

        <button
          (click)="viewCertificate()"
          [appButton]="exchangeIcon"
          appMenuItem
          class="solid for-select">
          {{ 'dashboard.ui.street_item.button.certificate' | translate }}
        </button>
      </div>
    </ng-template>
  </app-menu>
</div>
